import React, { useEffect, useState } from "react";
import Header from "../../common/Header.js";
import { Link, useNavigate, useParams } from "react-router-dom";
import { routes } from "../../../utlis/user/routes.utlis.js";
import "../../../assets/user/css/home.css";
import { api } from "../../../utlis/admin/api.utlis.js";
import Loader from "../../../layouts/loader/Loader";
import ApiService from "../../../core/services/ApiService";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import { decode, encode } from "base-64";

const BlogDetail = () => {
  const { id: blogId, slug } = useParams();
  const [details, setDetails] = useState();
  const [relatedBlogs, setRelatedBlogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const renderHTML = (rawHTML) =>
    React.createElement("div", {
      dangerouslySetInnerHTML: { __html: rawHTML },
    });

   const getBlogDetail = async (decodedId) => {
    setLoading(true);
    try {
      const response = await ApiService.getAPI(api.blogDetails + decodedId);
      if (response.data.status && response.data.statusCode === 200) {
        const responseData = response.data.data;
        if (responseData.blog) {
          // New format with blog and relatedBlogs
          setDetails(responseData.blog);
          setRelatedBlogs(responseData.relatedBlogs || []);
        } else {
          // Old format with direct blog data
          setDetails(responseData);
          setRelatedBlogs([]);
        }
        } else {
        setDetails(null);
        setRelatedBlogs([]);
      }
    } catch (error) {
      console.error('Error fetching blog:', error);
      setDetails(null);
      setRelatedBlogs([]);
    }
    setLoading(false);
  };


 useEffect(() => {
    window.scrollTo(0, 0);
    const decodedId = decode(blogId);
    getBlogDetail(decodedId);
  }, [blogId]);


  return (
    <>
      {loading ? <Loader /> : null}
      <Header></Header>
      <div className="care-provider-blog-section blog-banner">
        <div className="container">
          <div className="w-100 text-left">
            <Link to={routes.blog} className="mb-3 btnjoincare">
              Back
            </Link>
          </div>
          <div className="blog-page-content">
            <div className="blog-banner-image">
              {details?.blog_image === null ||
                details?.blog_image === "" ||
                details?.blog_image === undefined ? (
                <img
                  src={NoImage}
                  alt=""
                  style={{
                    objectFit: "cover",
                    objectPosition: "center",
                  }}
                />
              ) : (
                <img
                  src={details?.blog_image}
                  alt=""
                  style={{
                    objectFit: "cover",
                    objectPosition: "center",
                  }}
                />
              )}
            </div>

            {/* <h2>
              {details?.title ?? "NA"}
            </h2>
            <div className="desc">
              {renderHTML(details?.content ?? "NA")}
            </div> */}
            <h2>
              {details?.title ?? "NA"}
            </h2>

            {/* ── Author + Publish Date ── */}
            <div className="blog-meta-info">
              <span className="blog-meta-author">
                <i className="mdi mdi-account"></i>
                {details?.author_name || "Admin"}
              </span>
              <span className="blog-meta-divider">|</span>
              <span className="blog-meta-date">
                <i className="mdi mdi-calendar"></i>
                {details?.created_date
                  ? new Date(details.created_date).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })
                  : "NA"}
              </span>
            </div>

            <div className="desc">
              {renderHTML(details?.content ?? "NA")}
            </div>
            {/* ── Related Blogs ── */}
            {relatedBlogs?.length > 0 && (
              <div className="related-blogs-section">
                <h3 className="related-blogs-title">Related Articles</h3>
                <div className="related-blogs-grid">
                  {relatedBlogs.map((blog) => (
                    <Link
                      key={blog.id}
                      to={`/blog/info/${encode(blog.id.toString())}/${blog.slug}`}
                      className="related-blog-card"
                    >
                      <div className="related-blog-image">
                        <img
                          src={blog.blog_image || NoImage}
                          alt={blog.title}
                          style={{
                            objectFit: "cover",
                            objectPosition: "center",
                          }}
                        />
                      </div>
                      <div className="related-blog-content">
                        <h4 className="related-blog-title">{blog.title}</h4>
                        <div className="related-blog-meta">
                          <span className="related-blog-author">
                            {blog.author_name || "Admin"}
                          </span>
                          <span className="related-blog-date">
                            {new Date(blog.created_date).toLocaleDateString("en-US", {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                            })}
                          </span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="care-provider-footer">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="care-provider-copyright">
                <p>&copy; 2025 Care-Exchange.com. All rights reserved.</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="care-provider-copyright text-end">
                <Link className="" to={routes.about}>
                  About Us
                </Link>{" "}
                &nbsp; | &nbsp;
                <Link className="" to={routes.contact}>
                  Contact Us
                </Link>{" "}
                &nbsp; | &nbsp;
                <Link className="" to={routes.term}>
                  Terms and Conditions
                </Link>{" "}
                &nbsp; | &nbsp;
                <Link className="" to={routes.privacy}>
                  Privacy Policy
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogDetail;
